export default "__VITE_ASSET__D48JIPl0__"